import { createFileRoute } from '@tanstack/react-router';

import { naturalPersonListScreen, naturalPersonListSearch, loadPersonMessages, loadPersonScreens } from '@/modules/person/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/pessoas-fisicas/todas/')({
  validateSearch: naturalPersonListSearch,
  staticData: { screen: naturalPersonListScreen },
  loader: () => loadPersonMessages(),
  component: lazyScreen(loadPersonScreens, 'NaturalPersonListScreen'),
});
